module.exports = [
	{
		name: 'My Profile',
		msgId: 71,
		namePme: 'Employee',
		msgIdPme: 171,
		open: true,
		class: '',
		icon: 'icon-user',
		titleUpdatable: true,
		wrapper: {
			element: '',
			attributes: {}
		},
		itemAttr: { id: 'drop-administration' },
		savedChildren: [],
		children: [
			{
				name: 'My Profile',
				url: '/profile',
				msgId: 3
			},
			{
				name: 'My Project',
				url: '/myproject',
				filmOnly: true,
				msgId: 2
			}
		]
	},
	{
		name: 'Production',
		namePme: 'Management',
		notForSingleUser: true,
		prodOnly: true,
		open: false,
		class: '',
		icon: 'icon-graph',
		wrapper: {
			element: '',
			attributes: {}
		},
		msgId: 18,
		msgIdPme: 118,
		itemAttr: { id: 'drop-production' },
		savedChildren: [],
		titleUpdatable: true,
		children: [
			{
				name: 'Crew Setup',
				url: '/project/users',
				notForMobile: true,
				canAccessUsersOnly: true,
				msgId: 300
			},
			{
				name: 'Locations',
				url: '/locations',
				filmOnly: true,
				msgId: 25
			},
			{
				name: 'Imports',
				url: '/imports',
				notForMobile: true,
				msgId: 241
			}
		]
	},
	{
		name: 'Configuration',
		canAccessConfigOnly: true,
		notForSingleProject: true,
		class: '',
		notForMobile: true,
		open: false,
		icon: 'icon-settings',
		wrapper: {
			element: '',
			attributes: {}
		},
		msgId: 26,
		itemAttr: { id: 'drop-configuration' },
		savedChildren: [],
		children: [
			{
				name: 'Project',
				namePme: 'Legal entity',
				canAccessConfigOnly: true,
				notForMobile: true,
				url: '/settings',
				msgId: 12,
				msgIdPme: 112
			}
		]
	},
	// Fin
	{
		name: 'Finance',
		msgId: 1110,
		namePme: 'Finance',
		msgIdPme: 1101,
		open: false,
		class: '',
		icon: 'icon-book-open',
		titleUpdatable: true,
		useFinance: true,
		wrapper: {
			element: '',
			attributes: {}
		},
		itemAttr: { id: 'drop-finance' },
		savedChildren: [],
		children: [
			{
				name: 'Timesheets planning',
				url: '/time-cards/planning',
				notForMobile: true,
				notForSingleUser: true,
				msgId: 845
			}
		]
	},
	{
		name: 'TheGreenShot',
		devOnly: true,
		show: false,
		icon: 'icon-star',
		class: '',
		open: false,
		wrapper: {
			element: '',
			attributes: {}
		},
		msgId: 41,
		itemAttr: { id: 'drop-translation' },
		savedChildren: [],
		children: [
			{
				name: 'Translations',
				url: '/translation',
				// icon: "icon-book-open",
				devOnly: true,
				msgId: 40
			},
			{
				name: 'All users',
				url: '/allUsers',
				// icon: "icon-people",
				devOnly: true,
				msgId: 36
			},
			{
				name: 'Projects',
				url: '/projects',
				// icon: "icon-film",
				devOnly: true,
				msgId: 37
			},
			{
				name: 'Licenses',
				url: '/licenseList',
				// icon: "icon-book-open",
				devOnly: true,
				msgId: 38
			},
			{
				name: 'Scripts',
				url: '/scripts',
				devOnly: true,
				msgId: 261
			},
			{
				name: 'Maintenance',
				url: '/maintenance',
				devOnly: true,
				msgId: 262
			}
		]
	}
];
